const messages = {
  ar: {
    translations: {
      signup: {
        title: "إنشاء حساب",
        toasts: {
          success: "تم إنشاء المستخدم بنجاح! قم بتسجيل الدخول!!!.",
          disabled:
            "تسجيل المستخدمين معطل حالياً. يرجى المحاولة مرة أخرى لاحقاً.",
          fail: "خطأ في إنشاء المستخدم. تحقق من البيانات المدخلة.",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          company: "اسم المنظمة",
          phone: "واتس اب (كود الدولة + الرقم)",
        },
        buttons: {
          submit: "تسجيل",
          login: "لديك حساب بالفعل؟ ادخل!",
        },
      },
      ticketInfo: {
        copyPhone: "نسخ الهاتف",
        quickMessages: "الردود السريعة",
        phonecopied: "تم نسخ الهاتف إلى الحافظة!",
        noPhone: "لا يوجد هاتف متاح للنسخ",
        copyError: "خطأ في نسخ الهاتف",
      },
      login: {
        title: "تسجيل الدخول",
        form: {
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          button: "الوصول",
        },
        buttons: {
          submit: "دخول",
          register: "ليس لديك حساب؟ أنشئ حساباً!",
        },
      },
      companies: {
        title: "تسجيل الشركة",
        form: {
          name: "اسم الشركة",
          plan: "الخطة",
          token: "الرمز المميز",
          submit: "تسجيل",
          success: "تم إنشاء الشركة بنجاح!",
        },
      },
      auth: {
        toasts: {
          success: "تم تسجيل الدخول بنجاح!",
        },
        dueDate: {
          expiration: "ينتهي اشتراكك في",
          days: "أيام!",
          day: "يوم!",
          expirationToday: "ينتهي اشتراكك اليوم!",
        },
        token: "الرمز المميز",
      },
      dashboard: {
        title: "لوحة التحكم",
        loadingMessage: "سيتم تحميل بيانات لوحة التحكم قريباً...",
        refreshing: "جاري تحديث البيانات...",
        pleaseWait: "يرجى الانتظار",
        refresh: "تحديث البيانات",
        filters: "المرشحات",
        filter: "تصفية ",
        general: {
          title: "معلومات عامة",
        },
        overview: {
          title: "نظرة عامة والتقييمات",
        },
        activity: {
          title: "النشاط حسب الفترة والأداء",
          daily: "النشاط اليومي",
          perHour: "النشاط بالساعة",
        },
        distribution: {
          title: "التوزيع حسب القناة والقسم",
          byChannel: "التوزيع حسب القناة",
          byQueue: "التوزيع حسب القسم",
          channels: "قنوات",
          queues: "أقسام",
        },
        hourly: {
          title: "النشاط بالساعة",
          peak: "الذروة",
          between: "بين",
          and: "و",
        },
        tabs: {
          indicators: "المؤشرات",
          assessments: "NPS",
          attendants: "المشغلين",
          weeklyOverview: "نظرة أسبوعية",
        },
        charts: {
          perDay: {
            title: "المحادثات اليوم: ",
          },
          messages: "الرسائل",
        },
        total: "الإجمالي",
        noData: "لا توجد بيانات متاحة",
        cards: {
          inAttendance: "في المحادثة",
          waiting: "في الانتظار",
          activeAttendants: "المشغلين النشطين",
          finalized: "منتهية",
          newContacts: "جهات اتصال جديدة",
          totalReceivedMessages: "الرسائل المستلمة",
          totalSentMessages: "الرسائل المرسلة",
          averageServiceTime: "المحادثة",
          averageWaitingTime: "الانتظار",
          status: "الحالة (الحالية)",
          activeTickets: "المحادثات النشطة",
          passiveTickets: "المحادثات غير النشطة",
          groups: "المجموعات",
          totalTickets: "إجمالي المحادثات",
        },
        users: {
          name: "الاسم",
          numberAppointments: "عدد المحادثات",
          statusNow: "الحالية",
          totalCallsUser: "إجمالي المحادثات لكل مستخدم",
          totalAttendances: "إجمالي المحادثات",
        },
        date: {
          initialDate: "التاريخ الأولي",
          finalDate: "التاريخ النهائي",
        },
        licence: {
          available: "متاح حتى",
        },
        assessments: {
          totalCalls: "إجمالي المحادثات",
          callsWaitRating: "محادثات تنتظر التقييم",
          callsWithoutRating: "محادثات بدون تقييم",
          ratedCalls: "محادثات مقيمة",
          evaluationIndex: "مؤشر التقييم",
          score: "النتيجة",
          prosecutors: "الداعمين",
          neutral: "المحايدين",
          detractors: "المنتقدين",
          ratingTooltip: "من المحادثات المقيمة",
        },
        tickets: {
          overview: "حالة المحادثات",
          timeline: "الجدول الزمني للمحادثات",
          created: "المحادثات المنشأة",
          active: "المحادثات النشطة حالياً",
          pending: "محادثات في انتظار الخدمة",
          completed: "محادثات مكتملة",
          demandActive: "الطلب النشط",
          demandPassive: "الطلب غير النشط",
          inAttendanceTooltip: "المحادثات التي يتم خدمتها الآن",
          waitingTooltip: "المحادثات التي لم يتم تعيينها لمشغل بعد",
          finalizedTooltip: "المحادثات التي تم إغلاقها وحلها",
          activeTicketsTooltip: "المحادثات التي بدأتها الشركة",
          passiveTicketsTooltip: "المحادثات التي بدأها العميل",
        },
        messages: {
          title: "الرسائل حسب الفترة",
          received: "المستلمة",
          sent: "المرسلة",
          total: "الإجمالي",
          ratio: "النسبة",
        },
        attendants: {
          performance: "ترتيب المشغلين",
          online: "متصل الآن",
        },
        topContacts: {
          title: "ترتيب جهات الاتصال",
          columns: {
            contact: "جهة الاتصال",
            tickets: "المحادثات",
            queue: "القسم",
            time: "الوقت",
          },
          noData: "لا توجد جهات اتصال للعرض",
          tooltip: "أفضل 10 جهات اتصال لديها أكثر محادثات مفتوحة في الفترة",
        },
        actions: {
          filter: "تصفية",
          refresh: "تحديث",
          fullscreen: "ملء الشاشة",
          exitFullscreen: "الخروج من ملء الشاشة",
        },
        online: "متصل الآن",
        serviceTime: "متوسط وقت الخدمة",
        waitingTime: "متوسط وقت الانتظار في الطابور",
        newContacts: "جهات اتصال جديدة في الفترة",
        fromLastMonth: "منذ الشهر الماضي",
        newContactsTooltip: "جهات اتصال جديدة مسجلة في الفترة المحددة",
        activeAttendantsTooltip: "عدد المشغلين المتاحين متصلين",
        timeMetrics: "مقاييس الوقت",
        firstResponseTooltip: "متوسط الوقت حتى الرد الأول من المشغل",
        resolutionRateTooltip: "نسبة المحادثات المحلولة من الإجمالي",
        reopenedTicketsTooltip: "المحادثات التي أعيد فتحها بعد الإغلاق",
        avgTicketsPerDayTooltip: "متوسط المحادثات اليومية في الفترة",
        firstResponseTime: "الرد الأول",
        sort: {
          ascending: "تصاعدي",
          descending: "تنازلي",
          orderBy: "ترتيب حسب",
          tickets: "عدد المحادثات",
          rating: "التقييم",
          waitTime: "وقت الانتظار",
          serviceTime: "وقت الخدمة",
        },
        ticketStatusFilterValues: {
          open: "مفتوح",
          pending: "قيد الانتظار",
          closed: "مغلق",
          group: "مجموعة",
          chatbot: "شات بوت",
          nps: "NPS",
          lgpd: "LGPD",
        },
      },
      whatsappStatus: {
        title: "حالة واتساب",
        subtitle: "أنشئ وشارك حالتك على واتساب",
        selectAccount: "اختر حساب واتساب",
        selectAccountPlaceholder: "حساب واتساب",
        uploadMedia: "رفع الوسائط",
        image: "صورة",
        video: "فيديو",
        audio: "صوت",
        statusText: "نص الحالة",
        statusTextPlaceholder: "اكتب حالتك هنا...",
        backgroundColor: "لون الخلفية",
        scheduleForLater: "جدولة لاحقاً",
        date: "التاريخ",
        time: "الوقت",
        repeat: "تكرار",
        noRepeat: "بدون تكرار",
        daily: "يومي",
        weekly: "أسبوعي",
        monthly: "شهري",
        endDate: "تاريخ الانتهاء",
        scheduleStatus: "جدولة الحالة",
        sendStatus: "إرسال الحالة",
        sending: "جاري الإرسال...",
        previousStatuses: "الحالات السابقة",
        republish: "إعادة النشر",
        sent: "تم الإرسال",
        failed: "فشل",
        scheduled: "مجدولة",
        pending: "قيد الانتظار",
        cancelled: "ملغاة",
        noStatuses: "لا توجد حالات سابقة",
        preview: "معاينة الحالة",
        myStatus: "حالتي",
        justNow: "الآن",
        replyToStatus: "الرد على الحالة...",
        previewPlaceholder: "ستظهر حالتك هنا",
        toasts: {
          success: "تم إرسال الحالة بنجاح!",
          scheduled: "تم جدولة الحالة بنجاح!",
          republished: "تم إعادة نشر الحالة بنجاح!",
          error: "خطأ في إرسال الحالة",
          selectWhatsapp: "اختر واتساب",
          addContent: "أدخل نصاً أو اختر وسائط",
          fileTooLarge: "الملف كبير جداً. الحد الأقصى:",
          noPermission: "ليس لديك إذن للوصول إلى هذه الصفحة",
        },
      },
      reports: {
        title: "تقرير الاستطلاعات المنجزة",

        operator: "المشغل",
        period: "الفترة",
        until: "حتى",
        date: "التاريخ",
        reportTitle: "التقارير",
        calls: "المحادثات",
        search: "الاستطلاعات",
        durationCalls: "مدة المحادثات",
        grupoSessions: "محادثات المجموعات",
        groupTicketsReports: {
          timezone: "Asia/Riyadh",
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          errorToast: "خطأ في إنشاء التقرير",
          back: "العودة",
          groupServiceReport: "تقرير محادثات المجموعات",
          loading: "جاري التحميل...",
          contact: "جهة الاتصال",
          dateOpen: "تاريخ الفتح",
          dateLastUpdated: "تاريخ آخر تحديث",
          agent: "من قام بالمحادثة",
          agentClosed: "من أغلق المحادثة",
          waitingAssistance: "في انتظار المحادثة",
          process: "في المحادثة",
        },
        researchReports: {
          response: "إجابة",
          active: "(نشط)",
          inactive: "(غير نشط)",
          quantity: "الكمية",
          percentage: "نسبة مئوية",
          title: "تقرير الاستطلاعات المنجزة",
          activeSearch: "بحث نشط",
          inactiveSearch: "بحث غير نشط",
        },
        ticketDurationDetail: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير مدة المحادثة",
          startService: "بداية المحادثة",
          lastUpdated: "آخر تحديث",
          lastAgent: "آخر مشغل",
          durationFinished: "المدة بعد الانتهاء",
        },
        ticketDuration: {
          title: "تقرير مدة المحادثات",
          contact: "جهة الاتصال",
          open: "مفتوحة",
          pending: "معلقة",
          finished: "منتهية",
          durationFinished: "مدة المنتهية",
          durationAfterFinished: "المدة بعد الانتهاء",
          actions: "الإجراءات",
        },
        ticketReports: {
          msgToast: "جاري إنشاء التقرير المضغوط، يرجى الانتظار.",
          title: "تقرير المحادثات",
        },
        exportExcel: {
          title: "تقارير المحادثات",
          startDate: "التاريخ الأولي",
          endDate: "التاريخ النهائي",
          notInformed: "غير محدد",
          columns: {
            id: "المعرف",
            connection: "الاتصال",
            contact: "جهة الاتصال",
            user: "المستخدم",
            queue: "الطابور",
            kanban: "كانبان",
            status: "الحالة",
            lastMessage: "آخر رسالة",
            openDate: "تاريخ الفتح",
            openTime: "وقت الفتح",
            closeDate: "تاريخ الإغلاق",
            closeTime: "وقت الإغلاق",
            supportTime: "وقت المحادثة",
            nps: "NPS",
          },
        },
        pdf: {
          title: "قائمة المحادثات المنجزة",
          exportTitle: "قائمة محادثات المجموعات المنجزة",
        },
      },
      todo: {
        newTask: "مهمة جديدة",
        add: "إضافة",
        task: "المهام",
      },
      contactImportWpModal: {
        title: "تصدير جهات الاتصال إلى إكسل",
        buttons: {
          downloadModel: "تحميل نموذج إكسل للاستيراد",
          closed: "إغلاق",
          import: "اختر ملف إكسل لاستيراد جهات الاتصال",
        },
      },
      connections: {
        title: "الاتصالات",
        waitConnection: "انتظر... سيتم إعادة تشغيل اتصالاتك!",
        newConnection: "اتصال جديد",
        restartConnections: "إعادة تشغيل الاتصالات",
        callSupport: "الاتصال بالدعم",
        newConnection: "اتصال جديد",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " اربط قنوات الخدمة الخاصة بك لاستقبال الرسائل وبدء المحادثات مع عملائك.",
        client: "العميل",
        connectedConnections: " الاتصالات المتصلة ",
        disconnectedConnections: "الاتصالات المنقطعة ",
        totalConnections: " إجمالي الاتصالات",
        total: "الإجمالي",
        connections: "اتصالات:",

        toasts: {
          deleted: "تم حذف الاتصال بنجاح!",
          closedimported: "نحن نغلق المحادثات المستوردة، يرجى الانتظار قليلاً",
        },
        confirmationModal: {
          closedImportedTitle: "إغلاق المحادثات المستوردة",
          closedImportedMessage: "إذا أكدت سيتم إغلاق جميع المحادثات المستوردة",
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
          disconnectTitle: "قطع الاتصال",
          disconnectMessage: "هل أنت متأكد؟ ستحتاج إلى قراءة رمز QR مرة أخرى.",
        },
        buttons: {
          add: "إضافة اتصال",
          disconnect: "قطع الاتصال",
          tryAgain: "حاول مرة أخرى",
          qrcode: "رمز QR",
          newQr: "رمز QR جديد",
          closedImported: "إغلاق جميع المحادثات المستوردة",
          preparing: "تجهيز الرسائل للاستيراد",
          importing: "استيراد رسائل الواتس اب",
          newQr: "رمز QR جديد",
          processed: "تمت المعالجة",
          in: "من",
          connecting: "جاري الاتصال",
        },
        typography: {
          processed: "تمت المعالجة",
          in: "من",
          date: "تاريخ الرسالة",
        },
        toolTips: {
          disconnected: {
            title: "فشل في بدء جلسة الواتس اب",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت وحاول مرة أخرى، أو اطلب رمز QR جديد",
          },
          qrcode: {
            title: "في انتظار قراءة رمز QR",
            content: "انقر على زر 'رمز QR' واقرأ رمز QR بهاتفك لبدء الجلسة",
          },
          connected: {
            title: "تم تأسيس الاتصال!",
          },
          timeout: {
            title: "فُقد الاتصال مع الهاتف",
            content:
              "تأكد من أن هاتفك متصل بالإنترنت والواتس اب مفتوح، أو انقر على زر 'قطع الاتصال' للحصول على رمز QR جديد",
          },
        },
        table: {
          name: "الاسم",
          status: "الحالة",
          lastUpdate: "آخر تحديث",
          default: "افتراضي",
          actions: "الإجراءات",
          session: "الجلسة",
          number: "رقم الواتس اب",
          color: "اللون",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "محادثة موجودة",
        },
        form: {
          message: "جهة الاتصال هذه في محادثة بالفعل:",
          user: "المشغل",
          queue: "الطابور",
          messageWait:
            "جهة الاتصال هذه تنتظر المحادثة بالفعل. اطلع على تبويب الانتظار!",
        },
        reusedTicketToast:
          "توجد محادثة مسبقاً لهذا جهة الاتصال على هذا الربط. جاري فتح المحادثة…",
      },
      showTicketLogModal: {
        title: {
          header: "السجلات",
        },
        options: {
          create: "تم إنشاء المحادثة.",
          chatBot: "تم بدء البوت.",
          queue: " - تم تحديد الطابور.",
          open: " بدأ المحادثة.",
          access: "دخل إلى المحادثة.",
          transfered: "نقل المحادثة.",
          receivedTransfer: "استلم المحادثة المنقولة.",
          pending: "أعاد إلى الطابور.",
          closed: "أغلق المحادثة",
          reopen: "أعاد فتح المحادثة",
          redirect: "- تم التوجيه",
          clientClosed: "العميل أغلق المحادثة",
        },
      },
      whatsappModal: {
        title: {
          add: "إضافة اتصال",
          edit: "تعديل الاتصال",
        },
        tabs: {
          general: "عام",
          messages: "الرسائل",
          assessments: "NPS",
          integrations: "التكاملات",
          schedules: "ساعات العمل",
        },
        form: {
          importOldMessagesEnable: "استيراد رسائل الجهاز",
          importOldMessages: "تاريخ بداية الاستيراد",
          importRecentMessages: "تاريخ نهاية الاستيراد",
          importOldMessagesGroups: "استيراد رسائل المجموعات",
          closedTicketsPostImported: "إنهاء المحادثات بعد الاستيراد",
          name: "الاسم",
          queueRedirection: "إعادة توجيه الطابور",
          queueRedirectionDesc:
            "اختر طابوراً لجهات الاتصال التي لا تملك طابوراً ليتم توجيهها",
          default: "افتراضي",
          group: "السماح بالمجموعات",
          timeSendQueue: "الوقت بالدقائق لإعادة التوجيه للطابور",
          importAlert:
            "تنبيه: عند الحفظ، سيتم إنهاء اتصالك، وستحتاج لقراءة رمز QR مرة أخرى لاستيراد الرسائل",
          groupAsTicket: "التعامل مع المجموعات كمحادثة",
          timeCreateNewTicket: "إنشاء محادثة جديدة في x دقائق",
          maxUseBotQueues: "إرسال البوت x مرات",
          maxUseInactiveTime: "إرسال تدفق عدم النشاط x مرات",
          timeUseBotQueues: "إرسال البوت في x دقائق",
          timeToReturnQueue: "الوقت للعودة للطابور بالدقائق",
          timeAwaitActiveFlow: "الوقت لانتظار تفعيل التدفق",
          expiresTicket: "إنهاء المحادثات المفتوحة بعد x دقائق",
          expiresTicketNPS: "إنهاء المحادثات المنتظرة للتقييم بعد x دقائق",
          maxUseBotQueuesNPS: "الحد الأقصى لعدد مرات إرسال التقييم",
          closeLastMessageOptions1: "من المشغل/العميل",
          closeLastMessageOptions2: "من المشغل",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          lgpdLinkPrivacy: "رابط سياسة الخصوصية",
          lgpdMessage: "رسالة ترحيب LGPD",
          lgpdDeletedMessages: "إخفاء الرسالة المحذوفة من جهة الاتصال",
          lgpdSendMessage: "طلب تأكيد جهة الاتصال دائماً",
          ratingMessage: "رسالة التقييم - المقياس يجب أن يكون من 0 إلى 10",
          token: "رمز للتكامل الخارجي",
          sendIdQueue: "الطابور",
          inactiveMessage: "رسالة عدم النشاط",
          timeInactiveMessage: "الوقت بالدقائق لإرسال تنبيه عدم النشاط",
          flowInactiveTime: "الوقت بالدقائق لإرسال تدفق عدم النشاط",
          whenExpiresTicket: "إنهاء المحادثات المفتوحة عندما تكون آخر رسالة من",
          expiresInactiveMessage: "رسالة الإنهاء بسبب عدم النشاط",
          prompt: "الموجه",
          collectiveVacationEnd: "التاريخ النهائي",
          collectiveVacationStart: "التاريخ الأولي",
          collectiveVacationMessage: "رسالة الإجازة الجماعية",
          queueIdImportMessages: "طابور لاستيراد الرسائل",
          isOficial: "رسمي",
          phone_number_id: "معرف رقم الهاتف",
          waba_id: "معرف Waba",
          send_token: "رمز الإرسال",
          business_id: "معرف العمل",
          phone_number: "رقم الهاتف",
          triggerIntegrationOnClose: "تفعيل التكامل عند إغلاق المحادثة",
          triggerIntegrationOnCloseMode: "الإجراء",
          enableIntegration: "تفعيل التكامل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        menuItem: {
          enabled: "مفعل",
          disabled: "معطل",
          triggerIntegrationOnCloseModeAsk: "السؤال",
          triggerIntegrationOnCloseModeTrigger: "التفعيل",
          minutes: "دقائق",
        },
        success: "تم حفظ الاتصال بنجاح.",
        errorSendQueue:
          "تم تحديد وقت لإعادة توجيه الطابور، لكن لم يتم اختيار طابور للتوجيه. يجب ملء الحقلين معاً",
        errorExpiresNPS: "مطلوب تحديد وقت للتقييم عند استخدام NPS.",
        errorRatingMessage: "مطلوب تحديد رسالة تقييم عند استخدام NPS.",
      },
      qrCode: {
        message: "اقرأ رمز QR لبدء الجلسة",
        modalTitle: "خطوات الاتصال",
        step1: "افتح واتساب على هاتفك",
        step2: "اضغط المزيد من الخيارات (أندرويد) أو الإعدادات (آيفون)",
        step3: "اختر \"الأجهزة المرتبطة\" ثم \"ربط جهاز\"",
        step4: "امسح رمز QR هذا للتأكيد",
        hintBelowQr: "وجّه كاميرا هاتفك إلى هذه الشاشة لالتقاط الرمز",
        remainingTime: "الوقت المتبقي",
        expireSoon: "ينتهي الرمز خلال ثوانٍ. إذا لم تتمكن من المسح، اطلب رمزًا جديدًا.",
        expiredHint: "قد يكون هذا الرمز منتهيًا. اطلب رمز QR جديدًا من قائمة الاتصالات.",
        waiting: "جاري إنشاء الرمز...",
        close: "إغلاق",
      },
      contacts: {
        title: "جهات الاتصال",
        toasts: {
          deleted: "تم حذف جهة الاتصال بنجاح!",
        },
        searchPlaceholder: "البحث...",
        conversationFlows: " تدفقات المحادثة",
        addFlow: "إضافة تدفق",
        editFlow: "تعديل التدفق ",
        confirmationModal: {
          deleteTitle: "حذف ",
          importTitlte: "استيراد جهات الاتصال",
          exportContact: "تصدير جهات الاتصال",
          deleteMessage:
            "هل أنت متأكد من حذف جهة الاتصال هذه؟ جميع المحادثات المرتبطة ستفقد.",
          blockContact: "هل أنت متأكد من حظر جهة الاتصال هذه؟",
          unblockContact: "هل أنت متأكد من إلغاء حظر جهة الاتصال هذه؟",
          importMessage: "هل تريد استيراد جميع جهات الاتصال من الهاتف؟",
          importChat: "استيراد المحادثات",
          wantImport: "هل تريد استيراد جميع المحادثات من الهاتف؟",
        },
        buttons: {
          import: "استيراد جهات الاتصال",
          add: "إضافة جهة اتصال",
          export: "تصدير جهة الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          wallet: "المحفظة",
        },
        menu: {
          importYourPhone: "استيراد من الجهاز الافتراضي",
          importToExcel: "استيراد / تصدير من إكسل",
          importexport: "استيراد / تصدير",
        },
      },
      forwardMessage: {
        text: "معاد التوجيه",
      },
      forwardMessageModal: {
        title: "إعادة توجيه الرسالة",
        buttons: {
          ok: "إعادة توجيه",
        },
      },
      promptModal: {
        form: {
          name: "الاسم",
          prompt: "الموجه",
          voice: "الصوت",
          max_tokens: "الحد الأقصى للرموز في الإجابة",
          temperature: "درجة الحرارة",
          apikey: "مفتاح API",
          max_messages: "الحد الأقصى للرسائل في التاريخ",
          voiceKey: "مفتاح API الصوت",
          voiceRegion: "منطقة الصوت",
        },
        success: "تم حفظ الموجه بنجاح!",
        title: {
          add: "إضافة موجه",
          edit: "تعديل الموجه",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
      },
      prompts: {
        title: "الموجهات",
        table: {
          name: "الاسم",
          queue: "القسم/الطابور",
          max_tokens: "الحد الأقصى لرموز الإجابة",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء!",
        },
        buttons: {
          add: "إضافة موجه",
        },
      },
      contactModal: {
        title: {
          add: "إضافة جهة اتصال",
          edit: "تعديل جهة الاتصال",
        },
        form: {
          mainInfo: "بيانات جهة الاتصال",
          extraInfo: "معلومات إضافية",
          name: "الاسم",
          number: "رقم الواتس اب",
          email: "البريد الإلكتروني",
          extraName: "اسم الحقل",
          extraValue: "القيمة",
          chatBotContact: "تعطيل البوت",
          termsLGDP: "تم قبول شروط LGPD في:",
          whatsapp: "مصدر الاتصال: ",
          assignWallet: "محفظة العميل",
        },
        buttons: {
          addExtraInfo: "إضافة معلومة",
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ جهة الاتصال بنجاح.",
        walletLinked: "تم ربط جهة الاتصال بمحفظتك بنجاح!",
        walletError: "المستخدم لا يملك طوابير مرتبطة",
        saveFirst: "يجب حفظ جهة الاتصال أولاً",
      },
      wallets: {
        title: "محافظ جهات الاتصال",
        searchPlaceholder: "البحث عن جهات الاتصال...",
        filterByUser: "تصفية حسب المستخدم",
        allUsers: "جميع المستخدمين",
        contact: "جهة الاتصال",
        user: "المستخدم",
        queue: "الطابور",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        actions: "الإجراءات",
        editWallet: "تعديل المحفظة",
        selectUser: "اختيار المستخدم",
        selectQueue: "اختيار الطابور",
        selectUserAndQueue: "اختر مستخدماً وطابوراً",
        cancel: "إلغاء",
        save: "حفظ",
        confirmDeleteTitle: "تأكيد الحذف",
        confirmDeleteMessage:
          "هل أنت متأكد من إزالة جهة الاتصال هذه من المحفظة؟",
        deleteSuccess: "تم إزالة جهة الاتصال من المحفظة بنجاح!",
        updateSuccess: "تم تحديث المحفظة بنجاح!",
        wallet: "المحفظة",
      },
      queueModal: {
        title: {
          queueData: "بيانات الطابور",
          text: "ساعات الخدمة",
          add: "إضافة طابور",
          edit: "تعديل الطابور",
          confirmationDelete: "هل أنت متأكد؟ جميع خيارات التكاملات ستحذف.",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          orderQueue: "ترتيب الطابور (البوت)",
          rotate: "التناوب",
          timeRotate: "وقت التناوب",
          typeRandomMode: "نوع التناوب",
          greetingMessage: "رسالة الترحيب",
          complationMessage: "رسالة الإنهاء",
          outOfHoursMessage: "رسالة خارج ساعات العمل",
          token: "الرمز المميز",
          integrationId: "التكامل",
          fileListId: "قائمة الملفات",
          closeTicket: "إغلاق المحادثة",
          queueType: "نوع القائمة",
          queueTypeButton: "زر",
          queueTypeList: "قائمة",
          buttonTextLabel: "نص الزر",
          buttonTextPlaceholder: "مثال: مبيعات، دعم، خروج",
          buttonTextHelper: "في واتساب نص الزر محدود بـ 20 حرفاً.",
          listOptionLabel: "نص خيار القائمة",
          listOptionPlaceholder: "أدخل النص الذي سيظهر لهذا الخيار",
          message: "رسالة الإرجاع",
          queue: "طابور النقل",
          integration: "التكامل",
          file: "قائمة الملفات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        bot: {
          title: "الخيارات",
          toolTipTitle: "أضف خيارات لبناء بوت المحادثة",
          toolTip:
            "إذا كان هناك خيار واحد فقط، سيتم اختياره تلقائياً، مما يجعل البوت يجيب برسالة الخيار ويتابع",
          selectOption: "اختر خياراً",
          text: "النص",
          attendent: "المشغل",
          queue: "الطابور",
          integration: "التكامل",
          file: "الملف",
          toolTipMessageTitle: "الرسالة مطلوبة للانتقال للمستوى التالي",
          toolTipMessageContent: "الرسالة مطلوبة للانتقال للمستوى التالي",
          selectUser: "اختر مستخدماً",
          selectQueue: "اختر طابوراً",
          selectIntegration: "اختر تكاملاً",
          addOptions: "إضافة خيارات",
        },
        serviceHours: {
          dayWeek: "يوم الأسبوع",
          startTimeA: "الوقت الأولي - الدوام أ",
          endTimeA: "الوقت النهائي - الدوام أ",
          startTimeB: "الوقت الأولي - الدوام ب",
          endTimeB: "الوقت النهائي - الدوام ب",
          monday: "الاثنين",
          tuesday: "الثلاثاء",
          wednesday: "الأربعاء",
          thursday: "الخميس",
          friday: "الجمعة",
          saturday: "السبت",
          sunday: "الأحد",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "إضافة مشروع",
          edit: "تعديل المشروع",
        },
        form: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          jsonContent: "محتوى Json",
          urlN8N: "الرابط",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "الوقت بالدقائق لانتهاء المحادثة",
          typebotKeywordFinish: "كلمة إنهاء المحادثة",
          typebotKeywordRestart: "كلمة إعادة تشغيل التدفق",
          typebotRestartMessage: "رسالة عند إعادة تشغيل المحادثة",
          typebotUnknownMessage: "رسالة الخيار غير الصحيح",
          typebotDelayMessage: "الفاصل الزمني (مللي ثانية) بين الرسائل",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          test: "اختبار البوت",
        },
        messages: {
          testSuccess: "تم اختبار التكامل بنجاح!",
          addSuccess: "تم إضافة التكامل بنجاح.",
          editSuccess: "تم تعديل التكامل بنجاح.",
        },
      },
      userModal: {
        warning: "لاستيراد الرسائل يجب قراءة رمز QR مرة أخرى !!!",
        title: {
          add: "إضافة مستخدم",
          edit: "تعديل المستخدم",
          updateImage: "تحديث الصورة",
          removeImage: "حذف الصورة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          farewellMessage: "رسالة الوداع",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          whatsapp: "الاتصال الافتراضي",
          allTicketEnable: "مفعل",
          allTicketDisable: "معطل",
          allTicket: "عرض المحادثات بدون طابور",
          allowGroup: "السماح بالمجموعات",
          canUseVoice: "Pode usar Voz (ligações)",
          defaultMenuOpen: "مفتوح",
          defaultMenuClosed: "مغلق",
          defaultMenu: "القائمة الافتراضية",
          defaultTheme: "المظهر الافتراضي",
          defaultThemeDark: "داكن",
          defaultThemeLight: "فاتح",
          allHistoric: "عرض محادثات الطوابير الأخرى",
          allHistoricEnabled: "مفعل",
          allHistoricDisabled: "معطل",
          allUserChat: "عرض محادثات المستخدمين الآخرين",
          userClosePendingTicket: "السماح بإغلاق المحادثات المعلقة",
          showDashboard: "عرض لوحة التحكم",
          allowRealTime: "عرض لوحة المحادثات",
          allowConnections: "السماح بإجراءات الاتصالات",
          showContacts: "عرض جهات الاتصال",
          showCampaign: "عرض الحملات",
          showFlow: "عرض التدفقات",
          allowWhatsappStatus: "نشر الحالة",
          enabled: "مفعل",
          disabled: "معطل",
        },
        tabs: {
          general: "عام",
          permissions: "الصلاحيات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addImage: "إضافة صورة",
          editImage: "تعديل الصورة",
        },
        success: "تم حفظ المستخدم بنجاح.",
      },
      companyModal: {
        title: {
          add: "إضافة شركة",
          edit: "تعديل الشركة",
        },
        form: {
          name: "الاسم",
          email: "البريد الإلكتروني",
          passwordDefault: "كلمة المرور",
          numberAttendants: "المستخدمون",
          numberConections: "الاتصالات",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ الشركة بنجاح.",
      },
      scheduleModal: {
        title: {
          add: "جدولة جديدة",
          edit: "تعديل الجدولة",
          message: "الرسالة",
        },
        form: {
          body: "الرسالة",
          contact: "جهة الاتصال",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          assinar: "إرسال التوقيع",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
          addSchedule: "إضافة جدولة",
        },
        success: "تم حفظ الجدولة بنجاح.",
      },
      tagModal: {
        title: {
          add: "علامة جديدة",
          edit: "تعديل العلامة",
          addKanban: "مسار جديد",
          editKanban: "تعديل المسار",
        },
        form: {
          name: "الاسم",
          color: "اللون",
          timeLane: "الوقت بالدقائق لإعادة التوجيه للمسار",
          nextLaneId: "المسار",
          greetingMessageLane: "رسالة ترحيب المسار",
          rollbackLaneId: "العودة للمسار بعد استئناف المحادثة",
        },
        buttons: {
          okAdd: "إضافة",
          okEdit: "حفظ",
          cancel: "إلغاء",
        },
        success: "تم حفظ العلامة بنجاح.",
        successKanban: "تم حفظ المسار بنجاح.",
      },
      fileModal: {
        title: {
          add: "إضافة قائمة ملفات",
          edit: "تعديل قائمة الملفات",
        },
        buttons: {
          okAdd: "حفظ",
          okEdit: "تعديل",
          cancel: "إلغاء",
          fileOptions: "إضافة ملف",
        },
        form: {
          name: "اسم قائمة الملفات",
          message: "تفاصيل القائمة",
          fileOptions: "قائمة الملفات",
          extraName: "رسالة لإرسالها مع الملف",
          extraValue: "قيمة الخيار",
        },
        success: "تم حفظ قائمة الملفات بنجاح!",
      },
      chat: {
        noTicketMessage: "اختر محادثة لبدء المراسلة.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ اسحب وأفلت الملفات في الحقل أدناه ⬇️",
          titleFileList: "قائمة الملف(ات)",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsManager: {
        questionCloseTicket: "هل تريد إغلاق جميع المحادثات؟",
        yes: "نعم",
        not: "لا",
        buttons: {
          newTicket: "جديدة",
          resolveAll: "حل الكل",
          close: "إغلاق",
          new: "جديدة",
        },
      },
      ticketsQueueSelect: {
        placeholder: "الطوابير",
      },
      tickets: {
        messageHidden: "رسالة مخفية",
        inbox: {
          closedAllTickets: "إغلاق جميع المحادثات؟",
          closedAllTicketsDescription: "هل أنت متأكد أنك تريد إغلاق جميع المحادثات في هذه التبويبة؟",
          closedAll: "إغلاق الكل",
          newTicket: "محادثة جديدة",
          yes: "نعم",
          no: "لا",
          open: "مفتوحة",
          resolverd: "محلولة",
        },
        toasts: {
          deleted: "المحادثة التي كنت فيها تم حذفها.",
        },
        notification: {
          message: "رسالة من",
        },
        tabs: {
          open: { title: "مفتوحة" },
          closed: { title: "محلولة" },
          search: { title: "البحث" },
        },
        search: {
          placeholder: "البحث في المحادثات والرسائل",
          filterConections: "تصفية حسب الاتصال",
          filterConectionsOptions: {
            open: "مفتوح",
            closed: "مغلق",
            pending: "معلق",
          },
          filterUsers: "تصفية حسب المستخدمين",
          filterContacts: "تصفية حسب جهات الاتصال",
          ticketsPerPage: "محادثات لكل صفحة",
        },
        buttons: {
          showAll: "الكل",
          returnQueue: "إرجاع للطابور",
          scredule: "جدولة",
          deleteTicket: "حذف المحادثة",
        },
        closedTicket: {
          closedMessage: "إغلاق المحادثة مع رسالة الوداع",
          closedNotMessage: "إغلاق المحادثة بدون رسالة الوداع",
        },
      },
      transferTicketModal: {
        title: "نقل المحادثة",
        fieldLabel: "اكتب للبحث عن المستخدمين",
        fieldQueueLabel: "النقل للطابور",
        fieldQueuePlaceholder: "اختر طابوراً",
        fieldWhatsapp: "اختر واتس اب",
        noOptions: "لم يتم العثور على مستخدم بهذا الاسم",
        msgTransfer: "ملاحظات - رسالة داخلية، لن تذهب للعميل",
        buttons: {
          ok: "نقل",
          cancel: "إلغاء",
        },
      },
      chatInternal: {
        new: "إنشاء مجموعة",
        modal: {
          conversation: "المحادثة",
          title: "الاسم",
          filterUsers: "اختيار الأعضاء",
          cancel: "إغلاق",
          save: "حفظ",
        },
        modalDelete: {
          title: "حذف المحادثة",
          message: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        },
      },
      ticketsList: {
        called: "المحادثة",
        today: "اليوم",
        missedCall: "مكالمة صوتية/فيديو فائتة في",
        pendingHeader: "في الانتظار",
        assignedHeader: "جاري المحادثة",
        groupingHeader: "المجموعات",
        closedHeader: "محلولة",
        noTicketsTitle: "لا شيء هنا!",
        noTicketsMessage: "لا توجد محادثة بهذه الحالة أو المصطلح المبحوث عنه",
        noQueue: "بدون طابور",
        buttons: {
          accept: "قبول",
          cancel: "إلغاء",
          start: "بدء",
          closed: "إغلاق",
          reopen: "إعادة فتح",
          transfer: "نقل",
          ignore: "تجاهل",
          exportAsPDF: "تصدير كـ PDF",
          kanbanActions: "خيارات الكانبان",
        },
        acceptModal: {
          title: "قبول المحادثة",
          queue: "اختيار القسم",
        },
        actions: {
          newTicket: "محادثة جديدة",
          search: "بحث",
          showMyTickets: "عرض محادثاتي",
          showAll: "عرض الكل",
          openFilters: "فتح الفلاتر",
          closeFilters: "إغلاق الفلاتر",
          closeAllTickets: "إغلاق جميع المحادثات",
          searchButton: "بحث",
          clearSearch: "مسح البحث",
          searchInMessages: "البحث في محتوى الرسائل",
          appliedFilters: "الفلاتر المطبقة",
          clearAllFilters: "مسح جميع الفلاتر",
          clearFilters: "مسح الفلاتر",
          clear: "مسح",
          newAttendance: "محادثة جديدة",
          resolved: "محلولة",
          newestFirst: "الأحدث أولاً",
          oldestFirst: "الأقدم أولاً",
          selectTicket: "اختيار المحادثة",
          attendances: "المحادثات",
        },
      },
      newTicketModal: {
        title: "إنشاء محادثة",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "حفظ",
          cancel: "إلغاء",
        },
      },
      SendContactModal: {
        title: "إرسال جهة اتصال",
        fieldLabel: "اكتب للبحث عن جهة الاتصال",
        add: "إضافة",
        buttons: {
          ok: "إرسال",
          cancel: "إلغاء",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "لوحة التحكم",
          connections: "الاتصالات",
          chatsTempoReal: "اللوحة",
          tickets: "المحادثات",
          quickMessages: "الردود السريعة",
          contacts: "جهات الاتصال",
          wallets: "المحافظ",
          queues: "الطوابير والبوت",
          tags: "العلامات",
          administration: "الإدارة",
          companies: "الشركات",
          users: "المستخدمون",
          settings: "الإعدادات",
          files: "قائمة الملفات",
          helps: "المساعدة",
          apisSubmenu: "واجهات API",
          messagesAPI: "API",
          apiOficialDocs: "API الرسمية",
          testInteractive: "اختبار أزرار/قائمة",
          schedules: "الجدولة",
          campaigns: "الحملات",
          annoucements: "الإعلانات",
          chats: "المحادثة الداخلية",
          financeiro: "المالية",
          queueIntegration: "التكاملات",
          version: "الإصدار",
          kanban: "الكانبان",
          prompts: "Talk.Ai",
          allConnections: "إدارة الاتصالات",
          reports: "التقارير",
          management: "الإدارة",
          automations: "الأتمتة",
        },
        appBar: {
          user: {
            profile: "الملف الشخصي",
            logout: "خروج",
            message: "مرحباً",
            messageEnd: "مرحباً بك في",
            active: "نشط حتى",
            goodMorning: "مرحباً،",
            myName: "اسمي",
            continuity: "وسأتابع محادثتك.",
            virtualAssistant: "المساعد الافتراضي",
            token: "رمز غير صالح، يرجى الاتصال بمسؤول المنصة.",
          },
          message: {
            location: "الموقع",
            contact: "جهة الاتصال",
          },
          notRegister: "لا يوجد سجل",
          refresh: "تحديث",
        },
      },
      languages: {
        undefined: "اللغة",
        "pt-BR": "البرتغالية",
        es: "الإسبانية",
        en: "الإنجليزية",
        tr: "التركية",
        ar: "العربية",
      },
      messagesAPI: {
        title: "API",
        toSend: "إرسال",
        textMessage: {
          number: "الرقم",
          body: "الرسالة",
          token: "الرمز المسجل",
          userId: "معرف المستخدم/المشغل",
          queueId: "معرف الطابور",
        },
        mediaMessage: {
          number: "الرقم",
          body: "اسم الملف",
          media: "الملف",
          token: "الرمز المسجل",
        },
        API: {
          title: "وثائق إرسال الرسائل",
          methods: {
            title: "طرق الإرسال",
            messagesText: "الرسائل النصية",
            messagesMidia: "الرسائل الوسائطية",
          },
          instructions: {
            title: "التعليمات",
            comments: "ملاحظات مهمة",
            comments1:
              "قبل إرسال الرسائل، يجب تسجيل الرمز المرتبط بالاتصال الذي سيرسل الرسائل. <br />للتسجيل، ادخل إلى قائمة 'الاتصالات'، انقر على زر تعديل الاتصال وأدخل الرمز في الحقل المخصص.",
            comments2:
              "رقم الإرسال يجب ألا يحتوي على قناع أو رموز خاصة ويجب أن يتكون من:",
            codeCountry: "كود الدولة",
            code: "كود المنطقة",
            number: "الرقم",
          },
          text: {
            title: "1. الرسائل النصية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
          media: {
            title: "2. الرسائل الوسائطية",
            instructions:
              "فيما يلي قائمة المعلومات المطلوبة لإرسال الرسائل النصية:",
          },
        },
      },
      notifications: {
        noTickets: "لا توجد إشعارات.",
      },
      triggerFlowModal: {
        title: "تفعيل التدفق",
        description:
          "اختر تدفقاً لتنفيذه في هذه المحادثة. ستتغير حالة المحادثة إلى 'بوت' أثناء التنفيذ.",
        selectFlow: "اختر تدفقاً",
        selectedFlow: "التدفق المختار",
        flowId: "معرف التدفق",
        noFlows: "لا توجد تدفقات نشطة",
        cancel: "إلغاء",
        trigger: "تفعيل التدفق",
        triggering: "جاري التفعيل...",
        success: "تم تفعيل التدفق بنجاح!",
        error: "خطأ في تفعيل التدفق",
      },
      quickMessages: {
        title: "الردود السريعة",
        searchPlaceholder: "البحث...",
        noAttachment: "بدون مرفق",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "هذا الإجراء لا يمكن التراجع عنه! هل تريد المتابعة؟",
        },
        selectMessage: "اختيار الرد السريع",
        hasMedia: "مع وسائط",
        global: "عام",
        noResultsFound: "لم يتم العثور على رد سريع لبحثك",
        noQuickMessages: "لا توجد ردود سريعة متاحة",
        buttons: {
          add: "إضافة",
          attach: "إرفاق ملف",
          cancel: "إلغاء",
          edit: "تعديل",
        },
        toasts: {
          success: "تم إضافة الاختصار بنجاح!",
          deleted: "تم حذف الاختصار بنجاح!",
        },
        dialog: {
          title: "الرسالة السريعة",
          shortcode: "الاختصار",
          message: "الرد",
          save: "حفظ",
          cancel: "إلغاء",
          geral: "السماح بالتعديل",
          add: "إضافة",
          general: "عام",
          visao: "السماح بالعرض",
        },
        table: {
          shortcode: "الاختصار",
          message: "الرسالة",
          actions: "الإجراءات",
          mediaName: "اسم الملف",
          status: "الحالة",
        },
      },
      contactLists: {
        title: "قوائم جهات الاتصال",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "قائمة جديدة",
        },
        dialog: {
          name: "الاسم",
          company: "الشركة",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },
      contactListItems: {
        title: "جهات الاتصال",
        searchPlaceholder: "البحث",
        buttons: {
          add: "جديد",
          lists: "القوائم",
          import: "استيراد",
        },
        dialog: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          okEdit: "تعديل",
          okAdd: "إضافة",
          add: "إضافة",
          edit: "تعديل",
          cancel: "إلغاء",
        },
        table: {
          name: "الاسم",
          number: "الرقم",
          whatsapp: "الواتس اب",
          email: "البريد الإلكتروني",
          actions: "الإجراءات",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
          importMessage: "هل تريد استيراد جهات الاتصال من هذا الملف؟ ",
          importTitlte: "استيراد",
        },
        toasts: {
          deleted: "تم حذف السجل",
        },
      },

      kanban: {
        title: "الكانبان",
        laneTicketCountTooltip: "التذاكر في هذا العمود: {{count}}",
        laneTicketCountAria: "{{count}} تذاكر في هذا العمود",
        laneTicketCountFilteredTooltip: "عرض {{filtered}} من {{total}} تذاكر في هذا العمود",
        laneTicketCountFilteredAria: "{{filtered}} من {{total}} تذاكر في هذا العمود",
        laneSearchTooltip: "تصفية حسب اسم أو رقم جهة الاتصال",
        laneSearchAria: "البحث عن جهة اتصال في هذا العمود",
        laneSearchPlaceholder: "اسم أو رقم جهة الاتصال",
        laneSearchClearAria: "مسح البحث",
        laneSearchNoResults: "لم يتم العثور على جهة اتصال في هذا العمود",
        searchPlaceholder: "البحث",
        subMenus: {
          list: "اللوحة",
          tags: "المسارات",
        },
        showingCardsPartial: "عرض {{visible}} من {{total}} بطاقات (حمّل المزيد لرؤية البقية).",
        loadMoreCards: "تحميل المزيد من البطاقات",
      },

      campaigns: {
        title: "الحملات",
        searchPlaceholder: "البحث",
        subMenus: {
          list: "القائمة",
          listContacts: "قائمة جهات الاتصال",
          settings: "الإعدادات",
        },
        settings: {
          randomInterval: "فاصل زمني عشوائي للإرسال",
          noBreak: "بدون فاصل",
          intervalGapAfter: "فاصل أكبر بعد",
          undefined: "غير محدد",
          messages: "رسائل",
          laggerTriggerRange: "فاصل إرسال أكبر",
          addVar: "إضافة متغير",
          save: "حفظ",
          close: "إغلاق",
          add: "إضافة",
          shortcut: "اختصار",
          content: "المحتوى",
        },
        buttons: {
          add: "حملة جديدة",
          contactLists: "قوائم جهات الاتصال",
        },
        table: {
          name: "الاسم",
          whatsapp: "الاتصال",
          contactList: "قائمة جهات الاتصال",
          option: "لا شيء",
          disabled: "معطل",
          enabled: "مفعل",
          status: "الحالة",
          scheduledAt: "الجدولة",
          completedAt: "مكتملة",
          confirmation: "التأكيد",
          actions: "الإجراءات",
        },
        dialog: {
          new: "حملة جديدة",
          update: "تعديل الحملة",
          readonly: "عرض فقط",
          help: "استخدم متغيرات مثل {الاسم}، {الرقم}، {البريد} أو حدد متغيرات مخصصة.",
          form: {
            name: "الاسم",
            message1: "الرسالة 1",
            message2: "الرسالة 2",
            message3: "الرسالة 3",
            message4: "الرسالة 4",
            message5: "الرسالة 5",
            confirmationMessage1: "رسالة التأكيد 1",
            confirmationMessage2: "رسالة التأكيد 2",
            confirmationMessage3: "رسالة التأكيد 3",
            confirmationMessage4: "رسالة التأكيد 4",
            confirmationMessage5: "رسالة التأكيد 5",
            messagePlaceholder: "محتوى الرسالة",
            whatsapp: "الاتصال",
            status: "الحالة",
            scheduledAt: "الجدولة",
            confirmation: "التأكيد",
            contactList: "قائمة جهات الاتصال",
            tagList: "العلامات",
            statusTicket: "حالة المحادثة",
            openTicketStatus: "مفتوحة",
            pendingTicketStatus: "معلقة",
            closedTicketStatus: "مغلقة",
            enabledOpenTicket: "مفعل",
            disabledOpenTicket: "معطل",
            openTicket: "فتح محادثة",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء الإرسال",
            restart: "إعادة تشغيل الإرسال",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          cancel: "تم إلغاء الحملة",
          restart: "تم إعادة تشغيل الحملة",
          deleted: "تم حذف السجل",
        },
      },
      campaignReport: {
        title: "تقرير",
        inactive: "غير نشطة",
        scheduled: "مجدولة",
        process: "قيد التنفيذ",
        cancelled: "ملغاة",
        finished: "منتهية",
        campaign: "الحملة",
        validContacts: "جهات اتصال صالحة",
        confirmationsRequested: "تأكيدات مطلوبة",
        confirmations: "تأكيدات",
        deliver: "مسلمة",
        connection: "الاتصال",
        contactLists: "قائمة جهات الاتصال",
        schedule: "الجدولة",
        conclusion: "الخلاصة",
      },
      announcements: {
        title: "الإعلانات",
        searchPlaceholder: "البحث",
        active: "نشط",
        inactive: "غير نشط",
        buttons: {
          add: "إعلان جديد",
          contactLists: "قوائم الإعلانات",
        },
        table: {
          priority: "الأولوية",
          title: "العنوان",
          text: "النص",
          mediaName: "الملف",
          status: "الحالة",
          actions: "الإجراءات",
        },
        dialog: {
          edit: "تعديل الإعلان",
          add: "إعلان جديد",
          update: "تعديل الإعلان",
          readonly: "عرض فقط",
          form: {
            priority: "الأولوية",
            title: "العنوان",
            text: "النص",
            mediaPath: "الملف",
            status: "الحالة",
            high: "عالية",
            medium: "متوسطة",
            low: "منخفضة",
            active: "نشط",
            inactive: "غير نشط",
          },
          buttons: {
            add: "إضافة",
            edit: "تحديث",
            okadd: "موافق",
            cancel: "إلغاء",
            close: "إغلاق",
            attach: "إرفاق ملف",
          },
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        toasts: {
          success: "تم تنفيذ العملية بنجاح",
          deleted: "تم حذف السجل",
        },
      },
      campaignsConfig: {
        title: "إعدادات الحملات",
      },
      queues: {
        title: "الطوابير والبوت",
        table: {
          name: "الاسم",
          color: "اللون",
          greeting: "رسالة الترحيب",
          orderQueue: "ترتيب الطابور (البوت)",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة طابور",
        },
        toasts: {
          success: "تم حفظ الطابور بنجاح",
          deleted: "تم حذف الطابور بنجاح",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! محادثات هذا الطابور ستبقى موجودة، لكن لن يكون لها طابور مخصص.",
        },
      },
      queue: {
        queueData: "البيانات",
      },
      queueSelect: {
        inputLabel: "الطوابير",
        inputLabelRO: "طوابير للقراءة فقط",
        withoutQueue: "بدون طابور",
      },
      reports: {
        title: "تقارير المحادثات",
        startDate: "التاريخ الأولي",
        endDate: "التاريخ النهائي",
        table: {
          id: "المحادثة",
          user: "المستخدم",
          dateOpen: "تاريخ الفتح",
          dateClose: "تاريخ الإغلاق",
          NPS: "NPS",
          status: "الحالة",
          whatsapp: "الاتصال",
          queue: "الطابور",
          actions: "الإجراءات",
          lastMessage: "آخر رسالة",
          contact: "العميل",
          supportTime: "وقت المحادثة",
        },
        buttons: {
          filter: "تطبيق المرشح",
          onlyRated: "المقيمة فقط",
          exportExcel: "تنزيل Excel",
        },
        searchPlaceholder: "البحث...",
        kanbanLane: "كانبان",
        kanbanLaneAll: "جميع المسارات",
      },
      queueIntegration: {
        title: "التكاملات",
        table: {
          id: "المعرف",
          type: "النوع",
          name: "الاسم",
          projectName: "اسم المشروع",
          language: "اللغة",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
        },
        buttons: {
          add: "إضافة مشروع",
        },
        searchPlaceholder: "البحث...",
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء! وسيتم إزالته من الطوابير والاتصالات المرتبطة",
        },
      },
      users: {
        title: "المستخدمون",
        table: {
          status: "الحالة",
          name: "الاسم",
          email: "البريد الإلكتروني",
          profile: "الملف الشخصي",
          startWork: "بداية العمل",
          endWork: "نهاية العمل",
          actions: "الإجراءات",
          ID: "المعرف",
        },
        buttons: {
          add: "إضافة مستخدم",
        },
        toasts: {
          deleted: "تم حذف المستخدم بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات المستخدم ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      compaies: {
        title: "الشركات",
        table: {
          ID: "المعرف",
          status: "نشط",
          name: "الاسم",
          email: "البريد الإلكتروني",
          password: "كلمة المرور",
          phone: "الهاتف",
          plan: "الخطة",
          active: "نشط",
          numberAttendants: "المشغلين",
          numberConections: "الاتصالات",
          value: "القيمة",
          namePlan: "اسم الخطة",
          numberQueues: "الطوابير",
          useCampaigns: "الحملات",
          useExternalApi: "Rest API",
          useFacebook: "فيسبوك",
          useInstagram: "إنستجرام",
          useWhatsapp: "واتس اب",
          useInternalChat: "المحادثة الداخلية",
          useSchedules: "الجدولة",
          createdAt: "تم الإنشاء في",
          dueDate: "الاستحقاق",
          lastLogin: "آخر دخول",
          folderSize: "حجم المجلد ",
          totalFiles: " إجمالي الملفات",
          lastUpdate: "آخر تحديث",
          actions: "الإجراءات",
          money: "ر.س",
          yes: "نعم",
          no: "لا",
          document: "السجل التجاري/الهوية",
          recurrence: "التكرار",
          monthly: "شهري",
          bimonthly: "شهرين",
          quarterly: "ربع سنوي",
          semester: "نصف سنوي",
          yearly: "سنوي",
          clear: "مسح",
          delete: "حذف",
          user: "المستخدم",
          save: "حفظ",
          generateInvoice: "إنشاء فاتورة",
        },
        buttons: {
          add: "إضافة شركة",
        },
        toasts: {
          deleted: "تم حذف الشركة بنجاح.",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteMessage:
            "جميع بيانات الشركة ستفقد. المحادثات المفتوحة لهذا المستخدم ستنقل للطابور.",
        },
      },
      plans: {
        form: {
          name: "الاسم",
          users: "المستخدمون",
          connections: "الاتصالات",
          campaigns: "الحملات",
          schedules: "الجدولة",
          enabled: "مفعل",
          disabled: "معطل",
          clear: "إلغاء",
          delete: "حذف",
          save: "حفظ",
          yes: "نعم",
          no: "لا",
          money: "ر.س",
          public: "عام",
          trial: "تجريبي",
          trialDays: "أيام التجربة",
          phraseListFlow: "تدفق الحملة (قوائم)",
          conversationFlow: "تدفق المحادثة",
          followUpFlow: "متابعة (قوالب)",
          phraseListFlowShort: "حملة",
          conversationFlowShort: "محادثة",
          followUpFlowShort: "متابعة",
        },
      },
      helps: {
        title: "مركز المساعدة",
        settings: {
          codeVideo: "كود الفيديو",
          description: "الوصف",
          clear: "مسح",
          delete: "حذف",
          save: "حفظ",
        },
      },
      schedules: {
        title: "الجدولة",
        date: "التاريخ",
        time: "الوقت",
        event: "الحدث",
        allDay: "اليوم كله",
        week: "الأسبوع",
        work_week: "الجدولة",
        day: "اليوم",
        month: "الشهر",
        previous: "السابق",
        next: "التالي",
        yesterday: "أمس",
        tomorrow: "غداً",
        today: "اليوم",
        agenda: "الأجندة",
        noEventsInRange: "لا توجد جدولة في هذه الفترة.",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه الجدولة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          contact: "جهة الاتصال",
          body: "الرسالة",
          sendAt: "تاريخ الجدولة",
          sentAt: "تاريخ الإرسال",
          status: "الحالة",
          actions: "الإجراءات",
        },
        buttons: {
          add: "جدولة جديدة",
        },
        toasts: {
          deleted: "تم حذف الجدولة بنجاح.",
        },
      },
      tags: {
        title: "العلامات",
        addColumns: "+ إضافة أعمدة",
        search: "البحث",
        seeTicket: "عرض المحادثة",
        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذه العلامة؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          id: "المعرف",
          name: "الاسم",
          kanban: "الكانبان",
          color: "اللون",
          tickets: "سجلات العلامات",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        buttons: {
          add: "علامة جديدة",
        },
        toasts: {
          deleted: "تم حذف العلامة بنجاح.",
        },
      },

      tagsKanban: {
        title: "المسارات",
        laneDefault: "مفتوحة",
        backToKanban: "العودة للكانبان",

        confirmationModal: {
          deleteTitle: "هل أنت متأكد من حذف هذا المسار؟",
          deleteMessage: "لا يمكن التراجع عن هذا الإجراء.",
        },
        table: {
          name: "الاسم",
          color: "اللون",
          tickets: "المحادثات",
          actions: "الإجراءات",
        },
        buttons: {
          add: "مسار جديد",
        },
        toasts: {
          deleted: "تم حذف المسار بنجاح.",
        },
      },

      files: {
        title: "قائمة الملفات",
        table: {
          name: "الاسم",
          contacts: "جهات الاتصال",
          actions: "الإجراءات",
        },
        toasts: {
          deleted: "تم حذف القائمة بنجاح!",
          deletedAll: "تم حذف جميع القوائم بنجاح!",
        },
        buttons: {
          add: "إضافة",
          deleteAll: "حذف الكل",
        },
        confirmationModal: {
          deleteTitle: "حذف",
          deleteAllTitle: "حذف الكل",
          deleteMessage: "هل أنت متأكد من حذف هذه القائمة؟",
          deleteAllMessage: "هل أنت متأكد من حذف جميع القوائم؟",
        },
      },
      holidays: {
        title: "العطلات المتكررة",
        infoText: "العطلات المتكررة - صالحة لأي عام. عند استلام رسالة في يوم عطلة نشط، سيتم إرسال وصف العطلة تلقائياً.",
        table: {
          dayMonth: "اليوم/الشهر",
          description: "الوصف",
          status: "الحالة",
          statusActive: "نشط",
          statusInactive: "غير نشط",
          actions: "الإجراءات",
        },
        buttons: {
          add: "إضافة",
        },
        modal: {
          createTitle: "عطلة جديدة",
          editTitle: "تعديل العطلة",
          month: "الشهر",
          day: "اليوم",
          description: "وصف العطلة",
          descriptionPlaceholder: "مثال: يوم الاستقلال",
          isActive: "عطلة نشطة",
          save: "حفظ",
          create: "إنشاء",
          cancel: "إلغاء",
          infoText: "ستكون هذه العطلة صالحة لأي عام (2025، 2026، 2027...)",
        },
        confirmationModal: {
          deleteTitle: "حذف العطلة",
          deleteMessage: "هل تريد حقاً حذف العطلة",
        },
        toasts: {
          created: "تم إنشاء العطلة بنجاح!",
          updated: "تم تحديث العطلة بنجاح!",
          deleted: "تم حذف العطلة بنجاح!",
        },
        empty: "لا توجد عطلات مسجلة",
      },
      settings: {
        success: "تم حفظ الإعدادات بنجاح.",
        title: "الإعدادات",
        tabs: {
          options: "الخيارات",
          plans: "الخطط",
          helps: "المساعدة",
          companies: "الشركات",
        },
        settings: {
          userCreation: {
            name: "إنشاء المستخدم",
            options: {
              enabled: "مفعل",
              disabled: "معطل",
            },
          },
          tabs: {
            options: "الخيارات",
            schedules: "المواعيد",
            plans: "الخطط",
            help: "المساعدة",
          },
          options: {
            disabled: "معطل",
            enabled: "مفعل",
            updating: "جاري التحديث...",
            creationCompanyUser: "إنشاء الشركة/المستخدم",
            evaluations: "التقييمات",
            officeScheduling: "جدولة المكتب",
            queueManagement: "الإدارة بالطابور",
            companyManagement: "الإدارة بالشركة",
            connectionManagement: "الإدارة بالاتصال",
            sendGreetingAccepted: "إرسال الترحيب عند قبول المحادثة",
            sendMsgTransfTicket: "إرسال رسالة نقل القسم/المشغل",
            checkMsgIsGroup: "تجاهل رسائل المجموعات",
            chatBotType: "نوع البوت",
            chatBotTypeText: "نص",
            chatBotTypeButton: "أزرار",
            chatBotTypeList: "قائمة",
            userRandom: "اختيار مشغل عشوائي",
            buttons: "الأزرار",
            acceptCallWhatsapp: "إعلام عدم قبول المكالمات في الواتس اب؟",
            sendSignMessage: "السماح للمشغل باختيار إرسال التوقيع",
            sendGreetingMessageOneQueues:
              "إرسال الترحيب عند وجود طابور واحد فقط",
            sendQueuePosition: "إرسال رسالة مع موقع الطابور",
            sendFarewellWaitingTicket: "إرسال رسالة الوداع في الانتظار",
            acceptAudioMessageContact: "قبول الصوتيات من جميع جهات الاتصال؟",
            enableLGPD: "تفعيل معاملة LGPD",
            requiredTag: "علامة إجبارية لإغلاق المحادثة",
            closeTicketOnTransfer: "إغلاق المحادثة عند النقل لطابور آخر",
            DirectTicketsToWallets: "نقل العميل تلقائياً للمحفظة",
            showNotificationPending: "إظهار إشعار للمحادثات المعلقة",
            markUnreadOnTransfer: "وصول المحادثة المنقولة كغير مقروءة",
          },
          customMessages: {
            sendQueuePositionMessage: "رسالة الموقع في الطابور",
            AcceptCallWhatsappMessage: "رسالة إعلام عدم قبول المكالمات",
            greetingAcceptedMessage: "رسالة الترحيب عند قبول المحادثة",
            transferMessage: "رسالة النقل - ${queue.name} = الطابور المقصود",
          },
          LGPD: {
            title: "LGPD",
            welcome: "رسالة الترحيب (LGPD)",
            linkLGPD: "رابط سياسة الخصوصية",
            obfuscateMessageDelete: "إخفاء الرسالة المحذوفة",
            alwaysConsent: "طلب الموافقة دائماً",
            obfuscatePhoneUser: "إخفاء رقم الهاتف للمستخدمين",
            enabled: "مفعل",
            disabled: "معطل",
          },
        },
      },
      messagesList: {
        scrollToBottom: "الانتقال إلى آخر رسالة",
        header: {
          assignedTo: "مخصص لـ:",
          dialogRatingTitle: "هل تريد ترك تقييم للخدمة للعميل؟",
          dialogClosingTitle: "إنهاء المحادثة مع العميل!",
          dialogRatingCancel: "حل مع رسالة الوداع",
          dialogRatingSuccess: "حل وإرسال التقييم",
          dialogRatingWithoutFarewellMsg: "حل بدون رسالة الوداع",
          ratingTitle: "اختر قائمة تقييم",
          notMessage: "لا توجد رسالة مختارة",
          amount: "قيمة الاستطلاع",
          buttons: {
            return: "إرجاع",
            resolve: "حل",
            reopen: "إعادة فتح",
            accept: "قبول",
            rating: "إرسال التقييم",
            enableIntegration: "تفعيل التكامل",
            disableIntegration: "تعطيل التكامل",
            logTicket: "سجلات المحادثة",
            requiredTag: "يجب تخصيص علامة قبل إغلاق المحادثة.",
            greetingAcceptedMessage: "يجب إعداد رسالة ترحيب عند قبول المحادثة.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderOpen: "اكتب رسالة أو اضغط / للردود السريعة",
        placeholderClosed: "أعد فتح أو اقبل هذه المحادثة لإرسال رسالة.",
        signMessage: "توقيع",
        privateMessage: "رسالة خاصة",
      },
      contactDrawer: {
        header: "بيانات جهة الاتصال",
        buttons: {
          edit: "تعديل جهة الاتصال",
          block: "حظر",
          unblock: "إلغاء الحظر",
        },
        extraInfo: "معلومات أخرى",
      },
      messageVariablesPicker: {
        label: "المتغيرات المتاحة",
        vars: {
          contactFirstName: "الاسم الأول",
          contactName: "الاسم",
          user: "المشغل",
          greeting: "الترحيب",
          protocolNumber: "البروتوكول",
          date: "التاريخ",
          hour: "الساعة",
          ticket_id: "رقم المحادثة",
          queue: "القسم",
          connection: "الاتصال",
        },
      },
      ticketOptionsMenu: {
        schedule: "جدولة",
        delete: "حذف",
        transfer: "نقل",
        registerAppointment: "ملاحظات جهة الاتصال",
        resolveWithNoFarewell: "إنهاء بدون وداع",
        acceptAudioMessage: "قبول صوتيات جهة الاتصال؟",
        appointmentsModal: {
          title: "ملاحظات المحادثة",
          textarea: "الملاحظة",
          placeholder: "أدخل هنا المعلومة التي تريد تسجيلها",
        },
        confirmationModal: {
          title: "حذف محادثة جهة الاتصال",
          titleFrom: "من جهة الاتصال ",
          message: "تنبيه! جميع الرسائل المتعلقة بالمحادثة ستفقد.",
        },
        buttons: {
          delete: "حذف",
          cancel: "إلغاء",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "موافق",
          cancel: "إلغاء",
        },
      },
      messageInput: {
        tooltip: {
          signature: "تفعيل/تعطيل التوقيع",
          privateMessage: "تفعيل/تعطيل الرسالة الخاصة",
          meet: "إرسال رابط مؤتمر فيديو",
          triggerFlow: "تفعيل التدفق",
        },
        type: {
          imageVideo: "الصور والفيديوهات",
          cam: "الكاميرا",
          contact: "جهة الاتصال",
          meet: "مكالمة فيديو",
          template: "قالب ميتا",
        },
        camera: {
          tabPhoto: "صورة",
          tabVideo: "تسجيل فيديو",
          preparing: "جاري تجهيز الكاميرا…",
          startRecord: "بدء التسجيل",
          stopSend: "إيقاف وإرسال",
          accessError: "تعذر استخدام الكاميرا. تحقق من أذونات المتصفح.",
        },
      },
      messageOptionsMenu: {
        delete: "حذف",
        reply: "رد",
        edit: "تعديل",
        forward: "إعادة توجيه",
        toForward: "إعادة توجيه",
        talkTo: "محادثة مع",
        confirmationModal: {
          title: "حذف الرسالة؟",
          message: "لا يمكن التراجع عن هذا الإجراء.",
        },
      },
      invoices: {
        table: {
          invoices: "الفواتير",
          details: "التفاصيل",
          users: "المستخدمون",
          connections: "الاتصالات",
          queue: "الطوابير",
          value: "القيمة",
          expirationDate: "تاريخ الاستحقاق",
          action: "الإجراء",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "يجب أن يكون هناك واتس اب افتراضي واحد على الأقل.",
        ERR_NO_DEF_WAPP_FOUND:
          "لم يتم العثور على واتس اب افتراضي. تحقق من صفحة الاتصالات.",
        ERR_WAPP_NOT_INITIALIZED:
          "جلسة الواتس اب هذه لم يتم تهيئتها. تحقق من صفحة الاتصالات.",
        ERR_WAPP_CHECK_CONTACT:
          "لا يمكن التحقق من جهة اتصال الواتس اب. تحقق من صفحة الاتصالات",
        ERR_WAPP_INVALID_CONTACT: "هذا ليس رقم واتس اب صالح.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "لا يمكن تحميل الوسائط من الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_INVALID_CREDENTIALS: "خطأ في المصادقة. حاول مرة أخرى.",
        ERR_SENDING_WAPP_MSG:
          "خطأ في إرسال رسالة الواتس اب. تحقق من صفحة الاتصالات.",
        ERR_DELETE_WAPP_MSG: "لا يمكن حذف رسالة الواتس اب.",
        ERR_OTHER_OPEN_TICKET: "يوجد محادثة مفتوحة لجهة الاتصال هذه بالفعل.",
        ERR_SESSION_EXPIRED: "انتهت الجلسة. يرجى الدخول.",
        ERR_USER_CREATION_DISABLED: "تم تعطيل إنشاء المستخدم من قبل المدير.",
        ERR_NO_PERMISSION: "ليس لديك صلاحية للوصول لهذا المورد.",
        ERR_DUPLICATED_CONTACT: "يوجد جهة اتصال بهذا الرقم بالفعل.",
        ERR_NO_SETTING_FOUND: "لم يتم العثور على إعداد بهذا المعرف.",
        ERR_NO_CONTACT_FOUND: "لم يتم العثور على جهة اتصال بهذا المعرف.",
        ERR_NO_TICKET_FOUND: "لم يتم العثور على محادثة بهذا المعرف.",
        ERR_NO_USER_FOUND: "لم يتم العثور على مستخدم بهذا المعرف.",
        ERR_NO_WAPP_FOUND: "لم يتم العثور على واتس اب بهذا المعرف.",
        ERR_CREATING_MESSAGE: "خطأ في إنشاء الرسالة في قاعدة البيانات.",
        ERR_CREATING_TICKET: "خطأ في إنشاء المحادثة في قاعدة البيانات.",
        ERR_FETCH_WAPP_MSG:
          "خطأ في جلب الرسالة من الواتس اب، ربما تكون قديمة جداً.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "هذا اللون مستخدم بالفعل، اختر لوناً آخر.",
        ERR_WAPP_GREETING_REQUIRED:
          "رسالة الترحيب مطلوبة عند وجود أكثر من طابور واحد.",
        ERR_OUT_OF_HOURS: "خارج ساعات العمل!",
      },
      messagesAPIInstructions: {
        endpoint: "نقطة النهاية:",
        method: "الطريقة:",
        post: "POST",
        headers: "الرؤوس:",
        headerAuthorization:
          "Authorization Bearer (الرمز المسجل) و Content-Type (application/json)",
        body: "المحتوى:",
        fieldNumber: '"number": "966555999999"',
        fieldBody: '"body": "الرسالة"',
        fieldUserId: '"userId": معرف المستخدم أو ""',
        fieldQueueId: '"queueId": معرف الطابور أو ""',
        fieldSendSignature: '"sendSignature": توقيع الرسالة - true/false',
        fieldCloseTicket: '"closeTicket": إنهاء المحادثة - true/false',
        singMessage: "توقيع الرسالة - true/false",
        closeTicket: "إنهاء المحادثة - true/false",
        testSend: "اختبار الإرسال",
      },
      recurrenceSection: {
        title: "التكرار",
        description:
          "يمكنك اختيار إرسال الرسالة بشكل متكرر واختيار الفاصل الزمني. إذا كانت رسالة لإرسالها مرة واحدة، لا تغير شيئاً في هذا القسم.",
        labelInterval: "الفاصل الزمني",
        intervalFilterValue: "قيمة الفاصل الزمني",
        sendAsManyTimes: " إرسال كم مرة",
        shipNormallyOnNonbusinessDays: " إرسال عادي في الأيام غير العمل",
        sendOneBusinessDayBefore: "إرسال يوم عمل قبل",
        sendOneBusinessDayLater: "إرسال يوم عمل بعد",
        options: {
          days: "أيام",
          weeks: "أسابيع",
          months: "أشهر",
          minutes: "دقائق",
        },
      },
      servicePanel: {
        allowRealTime: "لوحة المحادثات",
      },
      financial: {
        invoices: "الفواتير",
        details: "التفاصيل",
        users: "المستخدمون",
        connections: "الاتصالات",
        queues: "الطوابير",
        value: "القيمة",
        expirationDate: "تاريخ الاستحقاق",
        status: "الحالة",
        action: "الإجراء",
      },
      statusFilter: {
        statusFilter: "تصفية حسب الحالة",
      },
      momentsUser: {
        services: "المحادثات:",
        pending: "معلقة",
        noqueue: "بدون طابور",
      },
      campaignsPhrase: {
        searchCampaign: "البحث عن حملة…",
        noSearchResults: "لا توجد حملات تطابق البحث.",
        campaignsFlow: "تدفق الحملات",
        campaigns: "الحملات",
        name: "الاسم",
        status: "الحالة",
        newCampaignWithFlowByPhrase: "حملة جديدة مع تدفق بالعبارة",
        editCampaignWithFlowByPhrase: "تعديل حملة مع تدفق بالعبارة",
        phraseTriggerName: "اسم التفعيل بالعبارة",
        chooseAStream: "اختر تدفقاً",
        whichPhraseTriggersTheFlow: " أي عبارة تفعل التدفق؟",
        selectAConnection: " اختر اتصالاً",
        chooseAStream: " اختر تدفقاً",
        status: " الحالة",
        cancel: "إلغاء",
        createCampaign: "إنشاء حملة ",
        saveCampaign: "حفظ الحملة",
      },
      whatsappModalRel: {
        form: {
          isOficial: "تقرير المحادثة",
          ticketId: "معرف المحادثة",
          client: "العميل",
          number: "الرقم",
          agent: "المشغل",
          date: "التاريخ",
          lastMessage: "آخر رسالة",
          fullReport: "التقرير الكامل مرفق أعلاه",
          resolveAndTriggerIntegration: "حل وتفعيل التكامل",
          elementNotFoundForExport: "العنصر غير موجود للتصدير.",
          reportFilename: "تقرير_المحادثة",
        },
      },
      chatList: {
        noMessages: "لا توجد رسائل",
        admin: "المدير",
        member: "عضو",
        searchChat: "البحث في المحادثة...",
        createNewChat: "إنشاء محادثة جديدة",
        searchUser: "البحث عن مستخدم...",
        noUserFound: "لم يتم العثور على مستخدم",
        noUserAvailable: "لا يوجد مستخدم متاح",
        cancel: "إلغاء",
        details: "التفاصيل",
        deleteChat: "حذف المحادثة",
        deleteChatConfirm: "لا يمكن التراجع عن هذا الإجراء، تأكيد؟",
        detailsTitle: "التفاصيل",
        edit: "تعديل",
        delete: "حذف",
        now: "الآن",
        minutesAgo: "{{count}} د مضت",
        hoursAgo: "{{count}} س مضت",
      },
      chatMessages: {
        deleted: "تم حذف هذه الرسالة",
        deletedAdmin: "رسالة محذوفة - مرئية للمديرين فقط",
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        cancel: "إلغاء",
        deleteMessage: "حذف الرسالة",
        deleteMessageConfirm: "هل أنت متأكد من حذف هذه الرسالة؟",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        doubleClickToReply: "انقر مرتين للرد",
        edited: "(معدلة)",
        forwarded: "(معاد توجيهها)",
        typeMessage: "اكتب رسالة...",
        send: "إرسال",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        replyingTo: "رد على",
        clickToGoToOriginal: "انقر للذهاب للرسالة الأصلية",
      },
      chatPopover: {
        reply: "رد",
        edit: "تعديل",
        delete: "حذف",
        forward: "إعادة توجيه",
        cancel: "إلغاء",
        confirmDelete: "تأكيد الحذف",
        confirm: "تأكيد",
        deleteMessage: "هل أنت متأكد من حذف هذه الرسالة؟",
        editMessage: "تعديل الرسالة",
        save: "حفظ",
        forwardMessage: "إعادة توجيه الرسالة",
        selectChat: "اختر المحادثة",
        forward: "إعادة توجيه",
        noChats: "لا توجد محادثة متاحة",
      },
      chatIndex: {
        chats: "المحادثات",
        groups: "المجموعات",
        new: "جديد",
        messages: "الرسائل",
        search: "البحث...",
        noChats: "لا توجد محادثة",
        noGroups: "لا توجد مجموعة",
        noMessages: "لا توجد رسائل",
        loading: "جاري التحميل...",
        error: "خطأ في تحميل البيانات",
        addGroupPhoto: "إضافة صورة المجموعة",
        changeGroupPhoto: "تغيير صورة المجموعة",
        groupName: "اسم المجموعة",
        groupDescription: "وصف المجموعة",
        save: "حفظ",
        cancel: "إلغاء",
        createGroup: "إنشاء مجموعة",
        editGroup: "تعديل المجموعة",
        deleteGroup: "حذف المجموعة",
        deleteGroupConfirm: "هل أنت متأكد من حذف هذه المجموعة؟",
        edit: "تعديل",
        delete: "حذف",
        details: "التفاصيل",
        groupDetails: "تفاصيل المجموعة",
        title: "العنوان",
        description: "الوصف",
        modal: {
          title: "إنشاء مجموعة",
          name: "اسم المجموعة",
          description: "وصف المجموعة",
          create: "إنشاء",
          cancel: "إلغاء",
          save: "حفظ",
          edit: "تعديل",
        },
        modal: {
          title: "إنشاء مجموعة",
          editTitle: "تعديل المجموعة",
          save: "حفظ",
          cancel: "إلغاء",
        },
      },
    },
  },
};

export { messages };
